import { render, staticRenderFns } from "./feedbackList.vue?vue&type=template&id=73a5e00d&scoped=true"
import script from "./feedbackList.vue?vue&type=script&lang=js"
export * from "./feedbackList.vue?vue&type=script&lang=js"
import style0 from "./feedbackList.vue?vue&type=style&index=0&id=73a5e00d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5e00d",
  null
  
)

export default component.exports